var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{attrs:{"title":"起草中心","url":"/approval/center","name":"更多"}},[_c('div',{staticClass:"list"},_vm._l((_vm.filteredList),function(item){return _c('router-link',{key:item.path,staticClass:"left item",attrs:{"to":item.path}},[_c('a-icon',{style:({
        color: item.color ? item.color : '#1890ff',
      }),attrs:{"type":"file-text","theme":"filled"}}),_c('span',{attrs:{"title":item.title}},[_vm._v(" "+_vm._s(item.title)+" ")])],1)}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }